import { Component ,Inject, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {MatDialog, MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material';
import {Credidentials} from '../../../shared/credidentials';
import { FormGroup, FormControl, FormBuilder,FormArray,Validators, NgForm } from '@angular/forms';

@Component({
    selector: 'dialog-result-example-dialog',
    templateUrl: 'dialog-result-example-dialog.component.html',
  })
  
  export class DialogResultExampleDialogComponent {
    user = {
      username: '',
      password: ''
    };
    model: any = {};
    constructor( 
      public dialogRef: MatDialogRef<DialogResultExampleDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
      private router: Router) {}
   
    
  }


// WEBPACK FOOTER //
// ./src/app/public/auth/login/dialog-result-example-dialog.component.ts